import { IQueryParamsList, IQueryParamsAssetTypeList } from '../types'

export const defaultParams: IQueryParamsList = {
    type: 'list',
    direction: 'ASC',
    orderBy: 'NAME',
    keyword: null,
    id: null
}

export const defaultParamsForResourceType: IQueryParamsAssetTypeList = {
    direction: 'ASC',
    orderBy: 'id',
    keyword: '',
    page: 1,
    perPage: 50
}
